module.exports = __webpack_public_path__ + "img/banner2.e24e0a4b.jpg";